// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__vhDPL","selectionInfo":"Footer_selectionInfo__U7hkx","toggleSelectionButton":"Footer_toggleSelectionButton__FtltM","buttons":"Footer_buttons__csrfJ"};